<template>
  <div class="shipping-group-total-item">
    <div class="shipping-group-total-item__label">
      <slot name="label">
        {{ label }}
      </slot>
    </div>

    <div class="shipping-group-total-item__separator" />

    <span
      v-if="isPriceNumber && oldPrice && oldPrice > price"
      class="shipping-group-total-item__old-price"
    >
      {{ oldPrice | price }}
    </span>

    <span class="shipping-group-total-item__price">
      <template v-if="isPriceNumber">{{ price | price }} ₽</template>
      <template v-else>{{ price }}</template>
    </span>

    <slot name="append" />
  </div>
</template>

<script>
export default {
  name: 'shipping-group-total-item',

  props: {
    price: {
      type: [Number, String],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    oldPrice: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    isPriceNumber() {
      return typeof this.price === 'number';
    }
  },
};
</script>

<style lang="scss">
.shipping-group-total-item {
  display: flex;
  align-items: center;
  color: $black;
  font-size: 12px;
  line-height: 16px;

  &:not(:last-child) {
    margin-bottom: 2px;
  }

  &__separator {
    display: block;
    flex: 1;
    margin: 0 4px;
    border-bottom: 1px dashed $gray_lu;
    transform: translateY(3px);
  }

  &__old-price {
    font-size: 10px;
    margin-right: 4px;
    color: $gray;
    text-decoration: line-through;
  }

  &__price {
    white-space: nowrap;
  }
}
</style>
